import { take } from 'redux-saga/effects';
import * as logger from '../utils/logger';

export const LOG_REQUEST = 'actions-logger/LOG_REQUEST';

export default {
  logRequest: payload => ({ type: LOG_REQUEST, payload })
};

const MAX_HISTORY_LENGTH = 50;

export function* actionsLoggerSaga() {
  while (true) {
    const action = yield take('*');

    try {
      const history = window.__actionsHistory || [];
      history.push(action);
      window.__actionsHistory = history.slice(
        Math.max(0, history.length - MAX_HISTORY_LENGTH),
        history.length
      );
    } catch (e) {
      logger.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/actions-logger.js